import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { Controller } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, TimeField } from "@mui/x-date-pickers";

interface QuestionnaireTimeInputProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    required?: boolean;
    error?: boolean;
    helperText?: string;
    disabled?: boolean;
    hiddenLabel?: boolean;
    defaultValue?: string;
    format?: string;
    sx?: any;
    InputProps?: any;
    InputLabelProps?: any;
    slotProps?: any;
}

/**
 * Componente de input de tempo padronizado para questionários
 */
export function QuestionnaireTimeInput({
    value,
    onChange,
    label,
    required = false,
    error = false,
    disabled = false,
    helperText,
    hiddenLabel = false,
    defaultValue,
    format = "HH:mm",
    sx,
    InputProps,
    InputLabelProps,
    slotProps,
}: QuestionnaireTimeInputProps) {
    const { control, setValue } = useForm({
        defaultValues: {
            field: value || ''
        }
    });

    useEffect(() => {
        setValue('field', value || '');
    }, [value, setValue]);

    return (
        <Controller
            name="field"
            control={control}
            defaultValue={value || ''}
            rules={{ required }}
            render={({ field: { onChange: fieldOnChange, value: fieldValue }, fieldState: { error: fieldError } }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimeField
                        sx={{
                            "& .MuiFilledInput-root": { backgroundColor: "neutral100.main" },
                            ...sx,
                        }}
                        slotProps={{
                            textField: {
                                error: !!fieldError || !!error,
                                placeholder: "--:--",
                                variant: "filled",
                                helperText: fieldError?.message || helperText || null,
                                required: required,
                                disabled: disabled,
                                InputLabelProps: {
                                    shrink: true,
                                    ...InputLabelProps
                                },
                                ...InputProps
                            },
                            ...slotProps
                        }}
                        label={label}
                        value={fieldValue}
                        onChange={(newValue) => {
                            fieldOnChange(newValue);
                            onChange(newValue || '');
                        }}
                        format={format}
                        fullWidth
                        hiddenLabel={hiddenLabel}
                    />
                </LocalizationProvider>
            )}
        />
    );
}

export default QuestionnaireTimeInput;
